import { useMutation, useQuery, useQueryClient } from 'react-query';
import { MutationType } from 'shared/types';
import request from 'utils/request';
import { BlockedTopicsResponseType, UpdateBlockedTopicsType } from './types';

export const useGetBlockedTopics = ({
  callback,
  refetchOnWindowFocus = false,
  enabled = true,
}: MutationType) => {
  return useQuery(
    'blocked-topics',
    async () => {
      const data = await request<BlockedTopicsResponseType>(
        '/blocked-keywords',
      );
      return data;
    },
    {
      onSuccess: (response) => {
        if (callback) callback(true, response);
      },
      onError: (error) => {
        if (callback) callback(false, error);
      },
      staleTime: refetchOnWindowFocus ? 10000 : 300000,
      refetchOnWindowFocus,
      enabled,
    },
  );
};

export const useUpdateBlockedTopics = ({ callback }: MutationType) => {
  const queryClient = useQueryClient();
  return useMutation(
    async (params: UpdateBlockedTopicsType) => {
      const { payload, isTopicExist } = params;
      const data = await request<BlockedTopicsResponseType>(
        '/blocked-keywords',
        payload,
        isTopicExist ? 'PUT' : 'POST',
      );
      return data;
    },
    {
      onSuccess: (response, params) => {
        queryClient.invalidateQueries('blocked-topics');
        if (callback) callback(true, response, params.updateType);
      },
      onError: (error, params) => {
        if (callback) callback(false, error, params.updateType);
      },
    },
  );
};
